// 用于上传缩略图转码
const base64toFile = (dataurl, filename = 'file') => {
    const arr = dataurl.split(',');
    const match = arr[0].match(/:(.*?);/)
    const mime = match && match[1] ? match[1] : '';
    const suffix = mime.split('/')[1] || '';
    const bstr = atob(arr[1] || '');
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
    });
};

// 用于上传资源转码
const unit8ArryToFile = (array, fullFileName, contentType) => new File(
    [array],
    fullFileName, {
        type: contentType
    }
);

export {
    base64toFile,
    unit8ArryToFile
};
